import React from 'react';
import { motion } from 'framer-motion';

const Contact = () => {
  return (
    <section className="min-h-screen py-20 px-6 bg-white/[0.02]" data-testid="contact-section">
      <div className="max-w-4xl mx-auto">
        <motion.h2
          initial={{ y: 30, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-5xl font-bold text-pure-white mb-12 text-center"
        >
          Get in Touch
        </motion.h2>

        <motion.div
          initial={{ y: 30, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2, duration: 0.5 }}
          className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10"
        >
          <p className="text-gray-400 mb-6 text-center">
            Feel Free to reach out!
          </p>

          {/* Google Form Embed - Replace with actual Google Form URL */}
          <div className="w-full" data-testid="google-form-embed">
            <iframe
              src="https://docs.google.com/forms/d/e/1FAIpQLSeVItVVA1gOGFDzUzVrmq3t-smLXQyFpEbmc-VJgDAtvnhxVw/viewform?usp=header"
              width="100%"
              height="776"
              // frameBorder="0"
              // marginHeight="0"
              // marginWidth="0"
              title="Contact Me!"
              className="rounded-xl border-0"
              // scrolling="no"
              style={{ overflow: 'hidden' }}
            >
              Loading…
            </iframe>
          </div>

          <div className="mt-8 text-center">
            <p className="text-gray-500 text-sm mb-4">Or reach out directly:</p>
            <div className="flex justify-center space-x-6">
              <a
                href="mailto:hello@nvsr.life"
                className="text-apple-blue hover:underline"
                data-testid="email-link"
              >
                📧 hello@nvsr.life
              </a>
              <a
                href="https://www.linkedin.com/in/nvsr0210"
                target="_blank"
                rel="noopener noreferrer"
                className="text-apple-blue hover:underline"
                data-testid="linkedin-link"
              >
                🔗 LinkedIn
              </a>
              <a
                href="https://github.com/niccolopaganini"
                target="_blank"
                rel="noopener noreferrer"
                className="text-apple-blue hover:underline"
                data-testid="github-link"
              >
                🐱 GitHub
              </a>
              <a
                href="https://calendly.com/hello-nvsr/30min"
                target="_blank"
                rel="noopener noreferrer"
                className="text-apple-blue hover:underline"
                data-testid="calendly-link"
              >
                📅 Schedule a Call
              </a>



            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;
